<template>
  <div>
    <div v-if="username == true" class="log_container">
      <commonTip
        :iType="0"
        :titleStr="tipTitle"
        v-if="isShowTip"
        @tipConfirm="tipSureAction"
      ></commonTip>
      <!-- <el-dialog title="智能客服" :visible.sync="username" width="20%" height="90%" :close-on-click-modal="false" :close-on-press-escape="false" 
			:show-close="false" center>
				<div class="inputs">
					<el-select v-model="station" filterable placeholder="请输入/选择站点ID" style="width: 250px; margin-bottom: 20px" @keyup.enter.native="nextUsername" @blur="searchBlur">
						<el-option v-for="(item , index) in stationItems" :key="index" :label="item.station" :value="item.value"></el-option>
					</el-select>
					<el-input v-model="name" autocomplete="off" placeholder="请输入用户名" style="width: 250px" id="webid" @keyup.enter.native="confirmWebid"></el-input>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="confirm(1)">下一步</el-button></span>
			</el-dialog> -->
      <img
        v-if="bind === false && QRcode === false"
        src="../../static/login/log_qrcode.png"
        class="img_board"
        @click="wechatLogin"
      />
      <img
        v-if="bind === false && QRcode === true"
        src="../../static/login/log_keyboard.png"
        class="img_board1"
        @click="inputLogin"
      />
      <div class="login_div">
        <div class="title_tip">智能客服</div>
        <div class="inputs" v-if="bind === false">
          <el-select
            v-if="QRcode === false"
            v-model="station"
            filterable
            placeholder="请输入/选择站点ID"
            style="width: 250px; margin-bottom: 20px"
            @keyup.enter.native="nextUsername"
            @blur="searchBlur"
          >
            <el-option
              v-for="(item, index) in stationItems"
              :key="index"
              :label="item.station"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input v-show="stationItems==[]" v-model="station" autocomplete="off" placeholder="请输入站点ID" style="width: 250px; margin-bottom: 20px" @keyup.enter.native="nextUsername"></el-input> -->
          <el-input
            v-if="QRcode === false"
            v-model="name"
            autocomplete="off"
            placeholder="请输入用户名"
            style="width: 250px"
            id="webid"
            @keyup.enter.native="confirmWebid"
          ></el-input>
        </div>
        <div class="inputs" v-if="bind === true">
          <div style="margin-bottom: 15px; font-size: 12px">
            请输入账号进行绑定
          </div>
          <el-input
            v-model="name"
            autocomplete="off"
            placeholder="请输入用户名"
            style="width: 250px; margin-bottom: 10px"
            id="webid"
            @keyup.enter.native="confirmWebid"
          >
          </el-input>
          <el-input
            v-model="password"
            show-password
            autocomplete="off"
            placeholder="请输入密码"
            style="width: 250px"
            id="webid"
            @keyup.enter.native="confirmWebid"
          ></el-input>
          <div style="width: 250px; margin-top: 10px">
            <el-input
              placeholder="请输入内容"
              v-model.trim="Vcode"
              style="width: 120px; float: left; margin-right: 10px"
            ></el-input>
            <el-button type="primary" v-show="show" @click="getCode"
              >获取验证码</el-button
            >
            <el-button type="primary" v-show="!show" :disabled="true"
              >{{ count }} s</el-button
            >
          </div>
          <el-button type="primary" @click="bindWeChat" style="margin-top: 30px"
            >立即绑定</el-button
          >
        </div>
        <div
          class="qrcode"
          id="login_QR"
          v-if="QRcode === true && bind === false"
          style="width: 400px; height: 400px"
        >
          <div style="color: #6a6a6a; margin-bottom: 7px">
            站点：{{ station }}
          </div>
          <div>
            <!-- qrData.qrCodeUrl -->
            <img :src="qrData.qrCodeUrl" style="width: 300px; height: 300px" />
            <div style="margin-top: 7px; text-align: center">
              请使用微信扫描公众号二维码进行登录
            </div>
            <div
              v-if="qrCodeTime === false"
              style="
                width: 300px;
                height: 300px;
                position: absolute;
                background: rgba(0, 0, 0, 0.7);
                margin-top: -332px;
              "
            >
              <div
                style="
                  z-index: 99;
                  color: white;
                  font-weight: bold;
                  line-height: 150px;
                  text-align: center;
                "
              >
                二维码失效，点击重新获取
              </div>
              <el-button
                style="z-index: 99; margin-left: 100px"
                type="primary"
                icon="el-icon-refresh"
                @click="refreshQRcode"
                >刷新</el-button
              >
            </div>
          </div>

          <!-- <wxlogin :appid="appid" :scope="scope" :state="state" :redirect_uri="getWechatQRcode" :href="href"></wxlogin> -->
        </div>
        <div
          style="width: 100%; display: flex; justify-content: center"
          v-if="bind === false"
        >
          <el-button v-if="QRcode === false" type="primary" @click="confirm(1)"
            >下一步</el-button
          >
          <!-- <el-button type="text" v-if="QRcode===true" @click="inputLogin">账号密码登录</el-button> -->
          <!-- <el-button type="text" v-if="QRcode===false" @click="wechatLogin" style="margin-left: 50px;">微信扫码登录</el-button> -->
        </div>
      </div>
    </div>
    <div class="NewUser" v-if="NewUser == true">
      <el-dialog
        title="智能客服"
        :visible.sync="NewUser"
        width="30%"
        @close="close"
        height="90%"
        :close-on-click-modal="false"
      >
        <div>你好，尊敬的新用户，欢迎使用本系统</div>
        <div>为了您的账号安全，请先设置登录密码</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirm(2)">下一步</el-button>
        </span>
      </el-dialog>
    </div>

    <div v-if="SetPassword == true">
      <el-dialog
        title="智能客服-设置密码"
        :visible.sync="SetPassword"
        @close="close"
        class="tanchuang"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="form" :rules="rules" ref="from">
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              line-height: 40px;
            "
            class="item_font"
          >
            <el-form-item label="请输入新密码" prop="password">
              <el-input
                type="password"
                v-model="form.password"
                autocomplete="off"
                style="width: 250px"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="再次确认输入" prop="newPassword">
              <el-input
                type="password"
                v-model="form.newPassword"
                autocomplete="off"
                style="width: 250px"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="setPassword = false" class="item_font"
            >取 消</el-button
          >
          <el-button type="primary" @click="confirm(3)" class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-if="MessageCode == true">
      <MsgCode
        @ReSend="ReSend"
        @successed="successed"
        :password="form.password"
        :username="name"
        :SMSCode="SMSCode"
        :equNo="equNo"
      ></MsgCode>
    </div>

    <div v-if="success == true">
      <el-dialog
        title="智能客服-新密码设置成功提示"
        :visible.sync="success"
        @close="close"
        class="tanchuang"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div style="" class="item_font">密码已设置成功， 稍后自动进入系统</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MsgCode from "../components/MessageCodeBox/index.js";
import commonTip from "../components/commonTip.vue";
// import config from "../utils/electronConfig.js";
// import {
// 	closeWebsocket
// } from '@/utils/websocket.js'
// import wxlogin from 'vue-wxlogin'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.newPassword != "") {
          this.$refs.form.validateField("newPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value != this.form.password) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        this.passwordChecked = true;
        callback();
      }
    };
    return {
      username: true,
      NewUser: false,
      SetPassword: false,
      success: false,
      MessageCode: false,
      station: "",
      name: "",
      passwordChecked: false,
      SMSCode: "1234",
      form: {
        password: "",
        newPassword: "",
      },
      rules: {
        password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
      isShowTip: false,
      tipTitle: "",
      stationItems: [],
      QRcode: false,
      bind: false,
      appid: "wxaeaff8dd52ca7a28",
      redirect_uri: "https%3A%2F%2Fmedibot.online%2Fweixin%2Fcallback",
      scope: "snsapi_login",
      state: "STATE",
      href: "",
      code: "https://open.weixin.qq.com",
      password: "",
      qrData: "", // 获取二维码
      qrCodeTime: true,
      Vcode: "",
      timer: "",
      qrState: "",
      qrResData: "", // 查询二维码状态的返回值
      show: true,
      count: "",
      timers: null,
      equNo: "",
    };
  },

  components: {
    MsgCode,
    commonTip,
    // wxlogin,
  },

  async beforeRouteEnter(to, from, next) {
    //从首页退出，正常显示登录界面 to:index from:home
    if (to.name === "index" && from.name === "home") {
      next((vm) => {
        const logout = vm.util.getLoginTip();
        if (logout === "0") {
          next();

          return;
        }
      });
    }
    // else if (to.name === 'index' && from.name === null) {
    // 	//直接点击登录界面的链接，检测是否是免登录用户 to:index from:null
    // 	next (async vm => {
    // 		const netState = vm.util.getLocalNetTip()
    // 		console.log('index beforeRouteEnter netstate = ', netState)
    // 		if (netState === '2') {
    // 			next()

    // 			return
    // 		}

    // 		let isFree = vm.util.getLocalFree()
    // 		console.log('index beforeRouteEnter isFree = ', isFree)
    // 		if (isFree === '1') {
    // 			let account = vm.util.getLocalAccount()
    // 			var loginApi = '/manager/user/pass/isChenkedLoginUser'
    // 			const response = await vm.util.postRequest({
    // 				url: loginApi,
    // 				method: 'POST',
    // 				data: {
    // 					loginName:account.loginName,
    // 					password:account.password,
    // 					isLogFree: true
    // 				}
    // 			})

    // 			console.log('index beforeRouteEnter response = ', response)
    // 			if (response.resultCode === '10000') {
    // 				const map = response.data.map
    // 				if (map !== null) {
    // 					const code = map.code
    // 					if (code === '0') {
    // 						//code -1 超过10天，需重新登录
    // 						//code 0 未超过10天，可直接跳到home界面
    // 						vm.util.setLoginTip(1)
    // 						vm.util.setLocalToken(response.token)

    // 						next({ path: '/home' })
    // 					}
    // 				}

    // 			} else {
    // 				vm.$message.error(response.desc)
    // 			}
    // 		}
    // 	})
    // }

    next();
  },

  created() {
    this.util.setLoginTip(0);
    const iWsState = this.util.getLocalWsState();

    if (this.$store.state.authority.type3Data !== null) {
      if (iWsState === "3" || iWsState === "4" || iWsState === "5") {
        this.util.pauseFlickerAudio();
        if (iWsState === "3") {
          let ipstr = "";
          ipstr = this.$store.state.authority.type3Data.data.ip;
          this.tipTitle = "你已被" + ipstr + "踢出 ！";

          this.tipTitle = this.$store.state.authority.type3Data.data.content;
          this.util.setWsState("0");
          this.isShowTip = true;
          this.$store.state.authority.type3Data = null;
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
        } else if (iWsState === "4") {
          this.tipTitle = "token已过期，请重新登录！";
          this.isShowTip = true;
          this.util.setWsState("0");
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
        } else if (iWsState === "5") {
          this.tipTitle = "缓存被清除，请重新登录！";
          this.isShowTip = true;
          this.util.setWsState("0");
          this.util.pauseFlickerAudio();
          this.util.setLoginTip(0);
          localStorage.setItem("token", null);
          // closeWebsocket()
        }
      } else if (
        iWsState === "0" &&
        this.$store.state.authority.type3Data.type == "3"
      ) {
        let ipstr = "";
        ipstr = this.$store.state.authority.type3Data.data.ip;
        this.tipTitle = "你已被" + ipstr + "踢出 ！";
        this.tipTitle = this.$store.state.authority.type3Data.data.content;
        this.isShowTip = true;
        this.$store.state.authority.type3Data = null;
        this.util.pauseFlickerAudio();
        this.util.setLoginTip(0);
        this.util.setWsState("0");
        localStorage.setItem("token", null);
      }
    } else {
      if (iWsState === "4") {
        this.tipTitle = "token已过期，请重新登录！";
        this.isShowTip = true;
        this.util.pauseFlickerAudio();
        this.util.setLoginTip(0);
        this.util.setWsState("0");
        localStorage.setItem("token", null);
      }
    }
  },

  mounted() {
    // console.log("localStorage.getItem('siteObj')",localStorage.getItem("siteObj"))
    sessionStorage.removeItem("siteObj");
    this.getStations();
    this.station =
      this.util.getLocalSite() != null ? this.util.getLocalSite().webId : "";
    this.name = JSON.parse(localStorage.getItem("username"));

    // let hrefList = this.$store.state.hrefData;

    // for (let item in hrefList) {
    //   hrefList[item].close();
    // }
    // this.$store.state.hrefData = {};
    // config.setHrefData(this.$store.state.hrefData);

    // let self = this
    // 	document.onkeydown = function(e) {
    // 		console.log("mouse enter",e)
    // 		let ev = document.all ? window.event : e
    // 		if (ev.keyCode === 13) {
    // 			self.confirm(1)
    // 		}
    // 	}
  },
  watch: {
    QRcode(val) {
      console.log("index QRcode/qrState value=====>", val, this.qrState);
    },
  },

  methods: {
    getCode() {
      if (this.name === "") {
        const text = "用户名不能为空";
        this.$message.error(text);
      } else if (this.password === "") {
        const text = "密码不能为空";
        this.$message.error(text);
      } else if (this.password.length < 6) {
        const text = "密码至少六位数";
        this.$message.error(text);
      } else {
        const TIME_COUNT = 59;
        this.getSMScode();
        if (!this.timers) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timers = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timers);
              this.timers = null;
            }
          }, 1000);
        }
      }
    },
    async confirm(num) {
      if (num == 1) {
        if (this.station === "") {
          const text = "站点不能为空";
          this.$message.error(text);
        } else if (this.name === "") {
          const text = "用户名不能为空";
          this.$message.error(text);
        } else {
          var api = "/projectchat/project/pass/selectByWebId";
          const response = await this.util.sitePostRequest({
            url: api,
            method: "POST",
            data: {
              webId: this.station.replace(/\s/g, ""),
            },
          });
          if (response.data !== null) {
            //   sessionStorage.setItem("webUrl", response.data.webUrl);
            //存储对象
            var site = JSON.stringify(response.data);
            localStorage.setItem("siteObj", site);
            localStorage.setItem("username", JSON.stringify(this.name));
            //登录
            this.addStation();
            this.toLogin();
          } else {
            localStorage.removeItem("siteObj");
            this.$message.error(response.desc);
          }
        }
      } else if (num == 2) {
        var equNoApi = "/manager/equipment/evn/check";
        const response = await this.util.postRequest({
          url: equNoApi,
          method: "POST",
          data: {
            loginName: this.name,
          },
        });
        console.log("equNoApi response========", response);
        if (response.resultCode == 10000) {
          this.equNo = response.data.equNo;
        }
        this.NewUser = false;
        this.SetPassword = true;
      } else if (num == 3) {
        if (this.passwordChecked == true) {
          this.SetPassword = false;
          this.MessageCode = true;
          this.getSMScode();
        }
      } else if (num == 4) {
        this.MessageCode = false;
        this.success = true;
      }
    },

    tipSureAction() {
      this.isShowTip = false;
    },

    async toLogin() {
      var loginApi = "/manager/user/pass/userJudgment";
      const response = await this.util.postRequest({
        url: loginApi,
        method: "POST",
        data: {
          loginName: this.name,
          version: "v1.8.0.4487",
        },
      });
      if (response.resultCode === "10000") {
        var flag = response.data.flag;
        if (flag == true) {
          console.log("新用户");
          this.username = false;
          this.NewUser = true;
        } else {
          console.log("老用户");
          this.$router.push({
            path: "/Login",
          });
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    close() {
      console.log("close");
    },
    ReSend() {
      this.getSMScode();
    },
    successed() {
      this.$router.push({
        path: "/home",
      });
    },
    async getSMScode() {
      var SMSapi = "/manager/user/pass/newUserSMS";
      await this.util.postRequest({
        url: SMSapi,
        method: "POST",
        data: {
          loginName: this.name,
        },
      });
    },
    confirmWebid(e) {
      // 处理输入登录名后enter键触发判断新老用户事件
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.confirm(1);
      }
    },
    nextUsername(e) {
      // 处理输入站点后enter键触发光标focus下一个input框用户名
      var keyCode = window.event ? e.keyCode : e.which;
      var inputs = document.getElementsByTagName("input");
      if (keyCode == 13) {
        inputs[1].focus();
      }
    },
    addStation() {
      let stations = [];
      if (localStorage.getItem("stations") != undefined) {
        stations = localStorage.getItem("stations").split(",");
      }

      if (stations != undefined && stations.length > 0) {
        if (stations.includes(this.station) == false) {
          stations.push(this.station);
        }
        localStorage.setItem("stations", stations);
      } else {
        localStorage.setItem("stations", this.station);
      }
    },
    getStations() {
      let stations = [];
      if (localStorage.getItem("stations") != undefined) {
        stations = localStorage.getItem("stations").split(",");
      }

      if (stations != null && stations.length > 0) {
        for (let i = 0; i < stations.length; i++) {
          console.log(stations[i]);
          this.stationItems.push({
            station: stations[i],
            value: stations[i],
          });
        }
      } else {
        this.stationItems = [];
      }
    },
    searchBlur(e) {
      this.station = e.target.value;
    },
    async getWechatQRcode() {
      // if(localStorage.getItem("QRcodeData")==null){

      // }else{
      // 	this.qrData = JSON.parse(localStorage.getItem("QRcodeData"))

      // }

      // 查询二维码
      var QRcodeapi = "/projectchat/weixin/getWechatQrCode";
      const response = await this.util.postRequest({
        url: QRcodeapi,
        method: "POST",
        data: {
          scene_str: this.station.replace(/\s/g, ""), //站点id
        },
        itype: "2",
      });
      this.qrData = response.data;
      console.log("QRcode", this.qrData);
      localStorage.setItem("QRcodeData", JSON.stringify(this.qrData));
      this.qrCodeTime = true;
      if (response.resultCode === "10000") {
        // this.getBindStatus()
        if (this.qrState != "") {
          clearInterval(this.qrState);
          this.qrState = "";
        }
        if (this.timer != "") {
          clearInterval(this.timer);
          this.timer = "";
        }
        this.timer = setInterval(this.setqrCodeTime, 300000); //300000 5分钟
        this.qrState = setInterval(this.getBindStatus, 1000);
      } else {
        this.$message.error(response.desc);
      }
    },
    inputLogin() {
      clearInterval(this.qrState);
      this.qrState = "";
      this.QRcode = false;
    },
    async wechatLogin() {
      // 微信登录按钮
      this.name = "";
      this.qrCodeTime = true;
      if (this.station === "") {
        const text = "站点不能为空";
        this.$message.error(text);
      } else {
        var api = "/projectchat/project/pass/selectByWebId";
        const response = await this.util.sitePostRequest({
          url: api,
          method: "POST",
          data: {
            webId: this.station.replace(/\s/g, ""),
          },
        });
        console.log("index confirm response = ", response);
        if (response.data !== null) {
          this.QRcode = true;
          var site = JSON.stringify(response.data);
          localStorage.setItem("siteObj", site);
          this.getWechatQRcode();
        } else {
          console.log("view index 站点验证失败");
          localStorage.removeItem("siteObj");
          this.$message.error(response.desc);
        }
      }
    },
    setqrCodeTime() {
      // localStorage.removeItem('QRcodeData')
      clearInterval(this.timer);
      clearInterval(this.qrState);
      this.timer = "";
      this.qrState = "";
      this.qrCodeTime = false;
    },
    refreshQRcode() {
      this.getWechatQRcode();
    },
    async getBindStatus() {
      // 查询扫码状态  0:未关注状态（即未扫码或扫码未关注）; 1:扫码关注未绑定;  2：已绑定
      var api = "/manager/weixin/getBindStatus/" + this.qrData.sceneStr;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      console.log("index getBindStatus response = ", response);
      this.qrResData = response.data;
      if (response.resultCode === "10000") {
        if (response.data.bindStatus === 0) {
          // 0: 未关注（即未扫码或扫码未关注）
        } else if (response.data.bindStatus === 1) {
          //1: 扫码关注未绑定
          // clearInterval(this.timer)
          clearInterval(this.qrState);
          this.qrState = "";
          this.bind = true;
        } else if (response.data.bindStatus === 2) {
          // 2: 已绑定
          // clearInterval(this.timer)
          clearInterval(this.qrState);
          this.qrState = "";
          var token = response.data.loginData.token;
          var account = response.data.loginData.bearUser;
          localStorage.setItem("token", token);
          localStorage.setItem("account", JSON.stringify(account));
          this.$router.push("/home");
          this.util.setLoginTip(1);
          this.getAuthorityRequest();
        }
      } else {
        this.$message.error(response.desc);
      }
    },
    bindWeChat() {
      // 微信公众号绑定
      if (this.name === "") {
        const text = "用户名不能为空";
        this.$message.error(text);
      } else if (this.password === "") {
        const text = "密码不能为空";
        this.$message.error(text);
      } else if (this.password.length < 6) {
        const text = "密码至少六位数";
        this.$message.error(text);
      } else if (this.Vcode == "") {
        const text = "验证码不能为空";
        this.$message.error(text);
      } else {
        this.bindCsUser();
      }
    },
    async bindCsUser() {
      // 微信公众号绑定
      var api = "/manager/weixin/bindCsUser";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          webId: this.station.replace(/\s/g, ""),
          unionId: this.qrResData.unionId,
          sceneId: this.qrData.sceneStr,
          loginName: this.name,
          passward: this.password,
          captcha: this.Vcode,
        },
      });
      console.log("index bindCsUser response = ", response);
      if (response.resultCode === "10000") {
        var token = response.data.loginData.token;
        var account = response.data.loginData.bearUser;
        localStorage.setItem("token", token);
        localStorage.setItem("account", JSON.stringify(account));
        this.$message.success("绑定成功");
        this.$router.push("/home");
        this.util.setLoginTip(1);
        this.getAuthorityRequest();
      } else {
        this.$message.error(response.desc);
      }
    },
    async getAuthorityRequest() {
      var api = "/manager/permission/getPermissionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAuthorityRequest response = ", response);
      if (response.resultCode === "10000") {
        this.setDefaultSetting();
        var tempObj = this.util.getLocalPermintObj();
        for (var i = 0; i < response.data.length; i++) {
          const chatPermi = response.data[i];
          if (chatPermi.name === "对话管理") {
            const permiList = chatPermi.permiVoList;
            for (var j = 0; j < permiList.length; j++) {
              var permit = permiList[j];
              if (permit.name === "关闭会话") {
                tempObj.endChat = permit.status == 1 ? true : false;
              } else if (permit.name === "勿扰设置") {
                tempObj.disturb = permit.status == 1 ? true : false;
              } else if (permit.name === "转接会话") {
                tempObj.transter = permit.status == 1 ? true : false;
              } else if (permit.name === "打标签") {
                tempObj.markTag = permit.status == 1 ? true : false;
              } else if (permit.name === "添加黑名单") {
                tempObj.defriend = permit.status == 1 ? true : false;
              } else if (permit.name === "接管会话") {
                tempObj.adapter = permit.status == 1 ? true : false;
              } else if (permit.name === "我的同事") {
                tempObj.colleage = permit.status == 1 ? true : false;
              } else if (permit.name === "疑似骚扰用户") {
                tempObj.trouble = permit.status == 1 ? true : false;
              } else if (permit.name === "转接给他人") {
                tempObj.transterTa = permit.status == 1 ? true : false;
              } else if (permit.name == "在线访客列表") {
                tempObj.isOnlineList = permit.status == 1 ? true : false;
              }else if (permit.name == "同事快捷回复展现") {
                tempObj.quickShow = permit.status == 1 ? true : false;
              }else if (permit.name == "公共快捷回复展现") {
                tempObj.publicQuickShow = permit.status == 1 ? true : false;
              }else if (permit.name == "已离开（未结束）列表") {
                tempObj.isOnlineOffList = permit.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "个人设置") {
            tempObj.personPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "系统设置") {
            tempObj.systemPmtList = this.util.normalizeSystemPmtList(
              chatPermi.permiVoList
            );
          } else if (chatPermi.name === "日志管理") {
            tempObj.log = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "留言管理") {
            tempObj.word = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "对话记录") {
            tempObj.record = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "开口机器人") {
            tempObj.bot = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "报表管理") {
            const permiList = chatPermi.permiVoList;
            for (var o = 0; o < permiList.length; o++) {
              var permit1 = permiList[o];
              if (permit1.name === "HTML报表下载") {
                tempObj.downHtml = permit1.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "Middleman管理") {
            tempObj.midmanPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "登录管理") {
            tempObj.loginmgList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          }
        }

        this.util.setLocalPermit(JSON.stringify(tempObj));
        // console.log("JSON.stringify(tempObj)", JSON.stringify(tempObj));
        this.$store.state.authority.isShowLog = this.util.getLocalPermit("log");
        this.$store.state.authority.isShowWord =
          this.util.getLocalPermit("word");
        this.$store.state.authority.isColleague =
          this.util.getLocalPermit("colleage");
        this.$store.state.authority.isTrouble =
          this.util.getLocalPermit("trouble");
        this.$store.state.authority.isEndChat =
          this.util.getLocalPermit("endChat");
        this.$store.state.authority.isTransfer =
          this.util.getLocalPermit("transter");
        this.$store.state.authority.isDefriend =
          this.util.getLocalPermit("defriend");
        this.$store.state.authority.isAdapter =
          this.util.getLocalPermit("adapter");
        this.$store.state.authority.isDisturb =
          this.util.getLocalPermit("disturb");
        this.$store.state.authority.isMarkTag =
          this.util.getLocalPermit("markTag");
        this.$store.state.authority.isShowBot = this.util.getLocalPermit("bot");
        this.$store.state.authority.isShowRecord =
          this.util.getLocalPermit("record");
        this.$store.state.authority.isOnlineList =
          this.util.getLocalPermit("isOnlineList");
        this.$store.state.authority.isOnlineOffList =
          this.util.getLocalPermit("isOnlineOffList");
          this.$store.state.authority.isQuickShow =
          this.util.getLocalPermit("quickShow");
          this.$store.state.authority.isPublicQuickShow =
          this.util.getLocalPermit("publicQuickShow");
        this.$store.state.authority.isTransferTa =
          this.util.getLocalPermit("transterTa");
        this.$store.state.authority.isDownHtml =
          this.util.getLocalPermit("downHtml");
        this.$store.state.authority.personList =
          this.util.getLocalPermit("personPmtList");
        this.$store.state.authority.systemList =
          this.util.getLocalPermit("systemPmtList");
        this.$store.state.authority.midmanList =
          this.util.getLocalPermit("midmanPmtList");
        this.$store.state.authority.loginmg =
          this.util.getLocalPermit("loginmgList");

        // this.$store.state.authority.systemList = this.util.getLocalPermit('systemPmtList')
      } else {
        this.$message.error(response.desc);
      }
    },
    setDefaultSetting() {
      console.log("msgCodeBox setDefaultSetting");
      var tempObj = {};
      tempObj.endChat = false;
      tempObj.disturb = false;
      tempObj.transter = false;
      tempObj.markTag = false;
      tempObj.defriend = false;
      tempObj.adapter = false;
      tempObj.colleage = false;
      tempObj.trouble = false;
      tempObj.personPmtList = [];
      tempObj.systemPmtList = [];
      // tempObj.systemPmtList = []
      tempObj.log = false;
      tempObj.word = false;
      tempObj.record = false;
      tempObj.bot = false;
      tempObj.transterTa = false;
      tempObj.downHtml = false;
      tempObj.quickShow = false;
      tempObj.publicQuickShow = false;
      this.util.setLocalPermit(JSON.stringify(tempObj));
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.log_container {
  width: 38vw;
  min-width: 500px;
  min-height: 320px;
  // max-height: 700px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 5px rgba(230, 230, 230, 0.5);
  border-radius: 20px;
  /* margin: 0 auto; */
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 30vw;
  // background-color: greenyellow;
}

.title_tip {
  width: 12.5rem;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  // background-color: cyan;
  @include change_size($font_size_normal) // @include header_font_color();
;
}

.img_board {
  align-self: flex-end;
  margin-right: 1.875rem;
  // background-color: orange;
  // margin-top: 0.625rem;
}

.img_board1 {
  align-self: flex-end;
  margin-right: 1.875rem;
  // background-color: orange;
  margin-top: 1.875rem;
  z-index: 100;
}

.login_div {
  /* background: #ffffff;
		box-shadow: 0px 0px 7px 5px rgba(230, 230, 230, 0.5);
		border-radius: 20px;
		width:100%; 
		height:15rem; */
  /* margin-top: 10rem; */
  margin: 0 auto;
  // background-color: orange;
  margin-top: -30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.inputs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 1.5625rem;
}

.qrcode {
  width: 12.5rem;
  height: 12.5rem;
  // background-color: rosybrown;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
